export const NOTES_MAX = 15;

export const textOverlap = (
  str: string | null | undefined,
  max = NOTES_MAX
): string => {
  const s = String(str ?? "");
  if (max < 0) return s;
  return s.length > max ? `${s.slice(0, max)}…` : s;
};
